(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  // 北京时间时区偏移（UTC+8，8小时 = 8 * 60 * 60 * 1000 毫秒）
  const BEIJING_TIMEZONE_OFFSET = 8 * 60 * 60 * 1000;
  
  // 获取服务器时间戳（从主题配置中获取）
  function getServerTimestamp() {
    if (window.T4Sconfigs && window.T4Sconfigs.nowTimestamp) {
      return window.T4Sconfigs.nowTimestamp;
    }
    // 如果配置还没加载，使用当前时间（不准确，但至少能工作）
    return Math.floor(Date.now() / 1000);
  }
  
  // 初始化所有倒计时
  function initBeijingCountdown() {
    const serverTimestamp = getServerTimestamp();
    const serverTimeMs = serverTimestamp * 1000;
    const countdownElements = document.querySelectorAll('[data-countdown-beijing]');
    
    if (countdownElements.length === 0) {
      return;
    }
    
    countdownElements.forEach(function(element, index) {
      // 检查是否已经初始化过（如果已经在运行，跳过）
      if (element.dataset.countdownInitialized === 'true' && element.dataset.countdownIntervalId === 'running') {
        return;
      }
      element.dataset.countdownInitialized = 'true';
      
      const endDate = element.getAttribute('data-end-date');
      const endTime = element.getAttribute('data-end-time') || '23:59:59';
      
      if (!endDate) return;
      
      // 解析结束时间（北京时间 UTC+8）
      const dateParts = endDate.split('/');
      const timeParts = endTime.split(':');
      
      if (dateParts.length !== 3 || timeParts.length < 2) return;
      
      const [year, month, day] = dateParts.map(Number);
      const [hours, minutes, seconds] = [
        Number(timeParts[0]),
        Number(timeParts[1] || 0),
        Number(timeParts[2] || 0)
      ];
      
      // 验证日期和时间有效性
      if (isNaN(year) || isNaN(month) || isNaN(day) || 
          isNaN(hours) || isNaN(minutes) || isNaN(seconds) ||
          month < 1 || month > 12 || day < 1 || day > 31 ||
          hours < 0 || hours > 23 || minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
        return;
      }
      
      // 将北京时间转换为 UTC 时间戳
      // 北京时间 = UTC + 8小时，所以 UTC = 北京时间 - 8小时
      // 使用 Date.UTC 创建 UTC 时间，将北京时间减去8小时
      let utcHours = hours - 8;
      let utcDay = day;
      let utcMonth = month - 1;
      let utcYear = year;
      
      // 处理跨天的情况（如果减去8小时后小时数小于0）
      if (utcHours < 0) {
        utcHours = 24 + utcHours;
        utcDay = day - 1;
        
        // 处理跨月的情况
        if (utcDay < 1) {
          utcMonth = month - 2;
          if (utcMonth < 0) {
            utcMonth = 11;
            utcYear = year - 1;
          }
          // 获取上个月的天数
          const daysInPrevMonth = new Date(Date.UTC(utcYear, utcMonth + 1, 0)).getDate();
          utcDay = daysInPrevMonth;
        }
      }
      
      const beijingEndTimestamp = Date.UTC(utcYear, utcMonth, utcDay, utcHours, minutes, seconds);
      
      // 确保元素可见（添加必要的 CSS 类）
      element.classList.add('t4s-countdown-enabled');
      const timeEl = element.querySelector('.time');
      if (timeEl) {
        timeEl.classList.add('t4s-countdown-enabled');
      }
      
      // 启动倒计时（不再传递 timeDiff，改为在函数内部动态计算）
      startCountdown(element, beijingEndTimestamp);
    });
  }
  
  function startCountdown(element, endTimestamp) {
    // 防止重复初始化：如果已经有定时器在运行，先清理
    if (element.dataset.countdownIntervalId === 'running') {
      // 清理之前的定时器
      if (element.dataset.countdownTimeoutId) {
        clearTimeout(parseInt(element.dataset.countdownTimeoutId));
      }
      if (element._countdownCleanup && typeof element._countdownCleanup === 'function') {
        element._countdownCleanup();
      }
    }
    
    const daysEl = element.querySelector('[data-countdown-days]');
    const hoursEl = element.querySelector('[data-countdown-hours]');
    const minutesEl = element.querySelector('[data-countdown-minutes]');
    const secondsEl = element.querySelector('[data-countdown-seconds]');
    
    // 获取标签元素（用于处理单复数）
    const daysLabelEl = element.querySelector('[data-countdown-label-days]');
    const hoursLabelEl = element.querySelector('[data-countdown-label-hours]');
    const minutesLabelEl = element.querySelector('[data-countdown-label-minutes]');
    const secondsLabelEl = element.querySelector('[data-countdown-label-seconds]');
    
    // 获取单复数文本（从data属性或文本内容）
    const getPluralText = function(labelEl, singularKey, pluralKey) {
      if (!labelEl) return '';
      const text = labelEl.textContent.trim();
      // 如果文本包含逗号，说明是 "单数,复数" 格式
      if (text.includes(',')) {
        return text.split(',');
      }
      // 否则返回单数形式
      return [text, text];
    };
    
    const daysLabels = getPluralText(daysLabelEl, 'day', 'days');
    const hoursLabels = getPluralText(hoursLabelEl, 'hr', 'hours');
    const minutesLabels = getPluralText(minutesLabelEl, 'min', 'minutes');
    const secondsLabels = getPluralText(secondsLabelEl, 'sec', 'seconds');
    
    // 确保元素可见
    element.classList.add('t4s-countdown-enabled');
    const timeEl = element.querySelector('.time');
    if (timeEl) {
      timeEl.classList.add('t4s-countdown-enabled');
    }
    
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      return;
    }
    
    // 记录初始化时的客户端时间和服务器时间，用于后续计算
    const initClientTime = Date.now();
    const initServerTimestamp = getServerTimestamp();
    const initServerTimeMs = initServerTimestamp * 1000;
    
    // 使用基于实际时间的精确更新机制，而不是固定的 setInterval
    // 这样可以避免浏览器节流和延迟导致的跳秒问题
    let lastUpdateTime = Date.now();
    let expectedNextUpdate = lastUpdateTime + 1000;
    let timeoutId = null; // 保存当前的 setTimeout ID，用于清理
    
    function updateCountdown() {
      const currentTime = Date.now();
      
      // 计算从初始化到现在的客户端时间流逝
      const clientElapsed = currentTime - initClientTime;
      
      // 计算当前准确的服务器时间 = 初始化时的服务器时间 + 客户端时间流逝
      // 这样可以避免服务器时间戳过时的问题，同时保持时间同步
      const now = initServerTimeMs + clientElapsed;
      
      const remaining = endTimestamp - now;
      
      if (remaining <= 0) {
        // 倒计时结束
        daysEl.textContent = '0';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        // 更新标签为复数形式
        if (daysLabelEl && daysLabels.length > 1) daysLabelEl.textContent = daysLabels[1];
        if (hoursLabelEl && hoursLabels.length > 1) hoursLabelEl.textContent = hoursLabels[1];
        if (minutesLabelEl && minutesLabels.length > 1) minutesLabelEl.textContent = minutesLabels[1];
        if (secondsLabelEl && secondsLabels.length > 1) secondsLabelEl.textContent = secondsLabels[1];
        element.classList.add('expired_cdt4');
        // 清理定时器和标记
        if (timeoutId !== null) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        element.dataset.countdownIntervalId = '';
        element.dataset.countdownTimeoutId = '';
        return;
      }
      
      // 计算剩余时间
      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      
      // 更新数字显示
      daysEl.textContent = days.toString();
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
      
      // 更新标签（单复数）
      if (daysLabelEl && daysLabels.length > 1) {
        daysLabelEl.textContent = days === 1 ? daysLabels[0] : daysLabels[1];
      }
      if (hoursLabelEl && hoursLabels.length > 1) {
        hoursLabelEl.textContent = hours === 1 ? hoursLabels[0] : hoursLabels[1];
      }
      if (minutesLabelEl && minutesLabels.length > 1) {
        minutesLabelEl.textContent = minutes === 1 ? minutesLabels[0] : minutesLabels[1];
      }
      if (secondsLabelEl && secondsLabels.length > 1) {
        secondsLabelEl.textContent = seconds === 1 ? secondsLabels[0] : secondsLabels[1];
      }
      
      // 记录本次更新时间
      lastUpdateTime = currentTime;
    }
    
    // 使用递归 setTimeout 实现精确的定时更新
    // 这样可以自动补偿延迟，避免累积误差
    function scheduleNextUpdate() {
      const currentTime = Date.now();
      const drift = currentTime - expectedNextUpdate;
      
      // 计算下一次更新的延迟时间，补偿已发生的延迟
      // 如果延迟超过 1000ms，立即更新；否则等待剩余时间
      const delay = Math.max(0, 1000 - drift);
      
      // 更新期望的下一次更新时间
      expectedNextUpdate = currentTime + delay;
      
      timeoutId = setTimeout(function() {
        updateCountdown();
        // 如果倒计时还没结束，继续调度下一次更新
        const currentTime2 = Date.now();
        const clientElapsed2 = currentTime2 - initClientTime;
        const now2 = initServerTimeMs + clientElapsed2;
        const remaining2 = endTimestamp - now2;
        
        if (remaining2 > 0) {
          scheduleNextUpdate();
        } else {
          // 倒计时结束，清理标记
          element.dataset.countdownIntervalId = '';
          timeoutId = null;
        }
      }, delay);
      
      // 保存 timeout ID 到元素上，以便在页面卸载时清理
      element.dataset.countdownTimeoutId = timeoutId.toString();
    }
    
    // 清理函数
    function cleanup() {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      element.dataset.countdownIntervalId = '';
      element.dataset.countdownTimeoutId = '';
    }
    
    // 保存清理函数到元素上，以便在页面卸载时调用
    element._countdownCleanup = cleanup;
    
    // 立即更新一次
    updateCountdown();
    
    // 启动精确的更新循环（使用递归 setTimeout，自动补偿延迟）
    scheduleNextUpdate();
    
    // 保存一个标记，表示倒计时正在运行
    element.dataset.countdownIntervalId = 'running';
  }
  
  // 页面加载完成后初始化
  function tryInit() {
    // 确保 T4Sconfigs 已加载，如果还没加载则等待
    if (!window.T4Sconfigs && document.readyState !== 'complete') {
      setTimeout(tryInit, 100);
      return;
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBeijingCountdown);
    } else {
      initBeijingCountdown();
    }
  }
  
  // 立即尝试初始化
  tryInit();
  
  // 也监听 window load 事件作为备用
  window.addEventListener('load', function() {
    const countdownElements = document.querySelectorAll('[data-countdown-beijing]');
    countdownElements.forEach(function(el) {
      // 只有在未初始化或没有运行的情况下才重新初始化
      if (el.dataset.countdownInitialized !== 'true' || el.dataset.countdownIntervalId !== 'running') {
        // 重置初始化标记，允许重新初始化
        if (el.dataset.countdownInitialized === 'true') {
          el.dataset.countdownInitialized = 'false';
        }
        initBeijingCountdown();
      }
    });
  });
  
  // 监听动态添加的元素
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.hasAttribute && node.hasAttribute('data-countdown-beijing')) {
              initBeijingCountdown();
            } else if (node.querySelectorAll) {
              const newCountdowns = node.querySelectorAll('[data-countdown-beijing]');
              if (newCountdowns.length > 0) {
                initBeijingCountdown();
              }
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // 页面卸载时清理所有定时器
  window.addEventListener('beforeunload', function() {
    const countdownElements = document.querySelectorAll('[data-countdown-beijing]');
    countdownElements.forEach(function(el) {
      // 清理定时器
      if (el.dataset.countdownTimeoutId) {
        clearTimeout(parseInt(el.dataset.countdownTimeoutId));
      }
      if (el._countdownCleanup && typeof el._countdownCleanup === 'function') {
        el._countdownCleanup();
      }
    });
  });
  
  // 页面隐藏时也清理（SPA 路由切换等情况）
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      // 页面隐藏时，清理定时器可以节省资源
      // 但这里我们不清理，因为页面重新可见时需要继续倒计时
      // 如果需要页面隐藏时暂停，可以在这里实现
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-discount-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__discountProductAjaxBound) return;
    window.__discountProductAjaxBound = true;

    // Shopify money formatting (reads from data attribute on modal)
    var modalRoot = document.getElementById('up-quick-shop-modal');
    var moneyFormat = (modalRoot && modalRoot.getAttribute('data-money-format')) || (window.Shopify && window.Shopify.money_format) || 'amount';
    if (typeof window.Shopify === 'undefined') window.Shopify = {};
    if (typeof window.Shopify.formatMoney !== 'function') {
      window.Shopify.formatMoney = function(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        var value = 0;
        var formatString = format || moneyFormat || 'amount';
        if (!isNaN(cents)) {
          value = parseInt(cents, 10);
        }

        function defaultOption(opt, def) {
          return (typeof opt === 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return '0'; }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.');
          var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          var centsPart = parts[1] ? (decimal + parts[1]) : '';
          return dollars + centsPart;
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var match = formatString.match(placeholderRegex);
        var valueString;

        switch (match && match[1]) {
          case 'amount':
            valueString = formatWithDelimiters(value, 2);
            break;
          case 'amount_no_decimals':
            valueString = formatWithDelimiters(value, 0);
            break;
          case 'amount_with_comma_separator':
            valueString = formatWithDelimiters(value, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            valueString = formatWithDelimiters(value, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            valueString = formatWithDelimiters(value, 2, '\u00A0', '.');
            break;
          case 'amount_with_period_and_space_separator':
            valueString = formatWithDelimiters(value, 2, '\u00A0', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            valueString = formatWithDelimiters(value, 0, '\u00A0');
            break;
          case 'amount_with_apostrophe_separator':
            valueString = formatWithDelimiters(value, 2, "'", '.');
            break;
          default:
            valueString = formatWithDelimiters(value, 2);
        }

        if (match) {
          return formatString.replace(placeholderRegex, valueString);
        }
        // Fallback: no token found in format string, return plain formatted number
        return valueString || formatWithDelimiters(value, 2);
      };
    }

    function showToast(message) {
      var toast = document.createElement('div');
      toast.className = 'up-toast';
      toast.textContent = message || 'Added to cart';
      document.body.appendChild(toast);
      requestAnimationFrame(function () {
        toast.classList.add('up-toast--show');
      });
      setTimeout(function () {
        toast.classList.remove('up-toast--show');
        setTimeout(function () {
          toast.remove();
        }, 200);
      }, 2000);
    }

    function onSubmit(e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('js-ajax-add-to-cart')) return;
      e.preventDefault();
      try {
        var data = new FormData(form);
        var id = data.get('id');
        var qty = data.get('quantity') || 1;
        if (!id) return;
        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: Number(qty) || 1 }),
        })
          .then(function (res) {
            return res.ok
              ? res.json()
              : res.json().then(function (err) {
                  throw err;
                });
          })
          .then(function () {
            if (button) button.disabled = false;
            // Optional: dispatch an event so other components (mini cart) can update
            document.dispatchEvent(new CustomEvent('cart:updated'));
            showToast('Added to cart');
          })
          .catch(function () {
            if (button) button.disabled = false;
            // Optional: simple fallback feedback
            console.error('Add to cart failed');
            showToast('Something went wrong');
          });
      } catch (err) {
        console.error(err);
      }
    }

    document.addEventListener('submit', onSubmit);

    // Quick Shop Modal functionality
    var quickShopModal = document.getElementById('up-quick-shop-modal');
    var quickShopModalBody = document.getElementById('up-quick-shop-modal-body');
    var quickShopModalClose = document.querySelector('.up-quick-shop-modal-close');

    function showQuickShopModal(productId, cardId) {
      if (!productId || productId === 'no-product') {
        showToast('Product not available');
        return;
      }
      
      // Show loading state
      quickShopModalBody.innerHTML = '<div style="text-align: center; padding: 20px;">Loading...</div>';
      quickShopModal.setAttribute('data-current-card-id', cardId);
      quickShopModal.classList.add('up-quick-shop-modal--show');
      
      // Get product data from the Buy Now button's data attribute
      var button = document.querySelector('[data-card-id="' + cardId + '"] .up-buy-now-btn');
      var productData = null;
      
      if (button && button.getAttribute('data-product-data')) {
        try {
          productData = JSON.parse(button.getAttribute('data-product-data'));
        } catch (e) {
          console.error('Error parsing product data:', e);
        }
      }
      
      if (productData) {
        var modalContent = generateQuickShopContent(productData, cardId);
        quickShopModalBody.innerHTML = modalContent;
          } else {
        quickShopModalBody.innerHTML = '<div style="text-align: center; padding: 20px;">Product data not available</div>';
      }
    }


    function generateQuickShopContent(product, cardId) {
      var selectedVariant = product.selected_or_first_available_variant;
      var hasMultipleVariants = product.variants && product.variants.length > 1;
      
      var content = '<div class="up-quick-shop-content">';
      content += '<h3 style="margin-bottom: 16px;">' + (product.title || 'Product') + '</h3>';
      
      // Variant buttons if multiple variants
      if (hasMultipleVariants) {
        content += '<div class="up-variant-buttons" style="margin-bottom: 16px;">';
        content += '<label style="display: block; margin-bottom: 8px; font-weight: 600;">Select Variant:</label>';
        content += '<div class="up-variant-btn-group" style="display: flex; flex-wrap: wrap; gap: 8px;">';
        
        product.variants.forEach(function(variant) {
          var selected = variant.id === selectedVariant.id ? 'selected' : '';
          var disabled = !variant.available ? 'disabled' : '';
          var btnClass = 'up-variant-btn';
          if (selected) btnClass += ' up-variant-btn--selected';
          if (disabled) btnClass += ' up-variant-btn--disabled';
          
          content += '<button type="button" class="' + btnClass + '" data-variant-id="' + variant.id + '" data-price="' + (variant.price || 0) + '" data-compare="' + (variant.compare_at_price || 0) + '" ' + (disabled ? 'disabled' : '') + '>' + variant.title + '</button>';
        });
        
        content += '</div>';
        content += '</div>';
      }
      
      // Price display
      content += '<div class="up-price-display" style="margin-bottom: 16px;">';
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        content += '<span style="text-decoration: line-through; color: #999; margin-right: 8px;">' + Shopify.formatMoney(selectedVariant.compare_at_price, moneyFormat) + '</span>';
      }
      content += '<span style="font-size: 18px; font-weight: bold;">' + Shopify.formatMoney(selectedVariant.price, moneyFormat) + '</span>';
      content += '</div>';
      
      // Quantity selector
      content += '<div class="up-quantity-selector" style="margin-bottom: 16px;">';
      content += '<label style="display: block; margin-bottom: 8px; font-weight: 600;">Quantity:</label>';
      content += '<input type="number" class="up-quantity-input" value="1" min="1" style="width: 80px; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">';
      content += '</div>';
      
      // Action buttons
      content += '<div class="up-quick-shop-actions" style="display: flex; gap: 12px;">';
      content += '<button type="button" class="up-add-to-cart-btn" style="flex: 1; background: #000; color: #fff; border: none; padding: 12px; border-radius: 4px; font-weight: 600; cursor: pointer;">Add to Cart</button>';
      content += '<button type="button" class="up-view-product-btn" style="flex: 1; background: #f0f0f0; color: #000; border: 1px solid #ddd; padding: 12px; border-radius: 4px; font-weight: 600; cursor: pointer;">View Product</button>';
      content += '</div>';
      content += '</div>';
      
      return content;
    }

    // using Shopify.formatMoney defined above

    function hideQuickShopModal() {
      quickShopModal.classList.remove('up-quick-shop-modal--show');
    }

    // Event listeners
    document.addEventListener('click', function(e) {
      // Buy Now button click - show Quick Shop modal (only for discount-product component)
      if (e.target.closest('.discount-product-card .up-buy-now-btn')) {
        var btn = e.target.closest('.up-buy-now-btn');
        var productId = btn.getAttribute('data-product-id');
        var cardId = btn.getAttribute('data-card-id');
        showQuickShopModal(productId, cardId);
      }
      
      // Cart drawer close events
      if (e.target.closest('[data-drawer-close]') || 
          e.target.closest('.drawer__close') ||
          e.target.closest('.cart-drawer__close') ||
          e.target.closest('.t4s-drawer__close')) {
        closeCartDrawer();
      }
      
      // Close cart drawer when clicking overlay
      if (e.target.classList.contains('t4s-drawer-overlay') || 
          e.target.classList.contains('cart-drawer-overlay')) {
        closeCartDrawer();
      }
      
      
      // Modal close
      if (e.target.closest('.up-quick-shop-modal-close') || e.target.closest('.up-quick-shop-modal')) {
        if (e.target === quickShopModal || e.target.closest('.up-quick-shop-modal-close')) {
          hideQuickShopModal();
        }
      }
      
      // Variant button selection
      if (e.target.closest('#up-quick-shop-modal .up-variant-btn')) {
        var btn = e.target.closest('.up-variant-btn');
        if (btn.disabled) return;
        
        // Remove selected class from all buttons
        var btnGroup = btn.closest('.up-variant-btn-group');
        var allBtns = btnGroup.querySelectorAll('.up-variant-btn');
        allBtns.forEach(function(button) {
          button.classList.remove('up-variant-btn--selected');
          // Reset to default styles
          button.style.background = '';
          button.style.borderColor = '';
          button.style.color = '';
        });
        
        // Add selected class to clicked button
        btn.classList.add('up-variant-btn--selected');
        btn.style.background = '#000';
        btn.style.borderColor = '#000';
        btn.style.color = '#fff';
        
        // Update price display
        var price = btn.getAttribute('data-price');
        var comparePrice = btn.getAttribute('data-compare');
        var priceDisplay = btn.closest('.up-quick-shop-content').querySelector('.up-price-display');
        if (priceDisplay) {
          var priceHtml = '';
          if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
            priceHtml += '<span style="text-decoration: line-through; color: #999; margin-right: 8px;">' + Shopify.formatMoney(comparePrice, moneyFormat) + '</span>';
          }
          priceHtml += '<span style="font-size: 18px; font-weight: bold;">' + Shopify.formatMoney(price, moneyFormat) + '</span>';
          priceDisplay.innerHTML = priceHtml;
        }
      }
      
      // Add to cart from modal
      if (e.target.closest('#up-quick-shop-modal .up-add-to-cart-btn')) {
        var btn = e.target.closest('.up-add-to-cart-btn');
        var modal = btn.closest('.up-quick-shop-content');
        var quantityInput = modal.querySelector('.up-quantity-input');
        var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        var variantId = null;
        var variantBtn = modal.querySelector('.up-variant-btn.up-variant-btn--selected');
        if (variantBtn) {
          // Get variant ID from the selected button
          variantId = variantBtn.getAttribute('data-variant-id');
        } else {
          // Fallback to original form variant ID
          var cardId = quickShopModal.getAttribute('data-current-card-id');
          var card = document.querySelector('[data-card-id="' + cardId + '"]');
          var form = card && card.querySelector('form.js-ajax-add-to-cart');
          var idInput = form && form.querySelector('input.js-variant-id');
          variantId = idInput ? idInput.value : null;
        }
        
        if (variantId) {
          addToCartFromModal(variantId, quantity);
        } else {
          showToast('Product variant not available');
        }
      }
      
      // View product from modal
      if (e.target.closest('#up-quick-shop-modal .up-view-product-btn')) {
        var btn = e.target.closest('.up-view-product-btn');
        var modal = btn.closest('.up-quick-shop-content');
        var cardId = quickShopModal.getAttribute('data-current-card-id');
        var card = document.querySelector('[data-card-id="' + cardId + '"]');
        var productLink = card && card.querySelector('a.up-discount-product-btn--view');
        if (productLink) {
          window.location.href = productLink.href;
        }
        hideQuickShopModal();
      }
    });

    function addToCartFromModal(variantId, quantity) {
      var button = document.querySelector('.up-add-to-cart-btn');
      if (button) button.disabled = true;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function(res) {
        return res.ok ? res.json() : res.json().then(function(err) { throw err; });
      })
      .then(function(data) {
        if (button) button.disabled = false;
        
        // Update cart count in header
        updateCartCount();
        
        // Dispatch cart:updated event for theme compatibility
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: data }
        }));
        
        // Dispatch custom event for cart drawer refresh
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { cart: data }
        }));
        
        showToast('Added to cart successfully!');
        hideQuickShopModal();
        
        // Open cart drawer with proper theme integration
        setTimeout(function() {
          openCartDrawer();
        }, 200);
      })
      .catch(function() {
        if (button) button.disabled = false;
        showToast('Something went wrong');
      });
    }
    
    function updateCartCount() {
      // Update cart count in header
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .t4s-cart-count');
          cartCountElements.forEach(function(element) {
            element.textContent = cart.item_count;
          });
        })
        .catch(function(error) {
          console.error('Error updating cart count:', error);
        });
    }
    
    function openCartDrawer() {
      // Try multiple selectors for cart drawer, prioritize t4s-mini_cart
      var cartDrawer = document.querySelector('#t4s-mini_cart') || 
                      document.querySelector('.t4s-drawer') || 
                      document.querySelector('[data-cart-drawer]') || 
                      document.querySelector('.cart-drawer') || 
                      document.querySelector('.mini-cart');
      
      if (cartDrawer) {
        // Remove hidden classes
        cartDrawer.classList.remove('t4s-dn', 't4s-drawer--hidden', 'cart-drawer--closed');
        cartDrawer.setAttribute('aria-hidden', 'false');
        
        // Ensure it's positioned on the right side
        if (!cartDrawer.classList.contains('t4s-drawer__right')) {
          cartDrawer.classList.add('t4s-drawer__right');
        }
        
        // Add open classes
        cartDrawer.classList.add('t4s-drawer--open', 'cart-drawer--open', 'is-open');
        document.body.classList.add('t4s-drawer-open', 'drawer-open', 'cart-drawer-open');
        
        // Add overlay if not exists
        var overlay = document.querySelector('.t4s-drawer-overlay, .cart-drawer-overlay');
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 't4s-drawer-overlay cart-drawer-overlay';
          overlay.setAttribute('data-drawer-close', '');
          document.body.appendChild(overlay);
        }
        overlay.style.display = 'block';
        overlay.classList.add('show');
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        
        // Trigger cart refresh if theme supports it
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
        
        // Force right-side positioning with inline styles if needed
        if (cartDrawer.id === 't4s-mini_cart') {
          cartDrawer.style.right = '0';
          cartDrawer.style.left = 'auto';
          cartDrawer.style.transform = 'translate3d(0, 0, 0)';
        }
      }
    }
    
    function closeCartDrawer() {
      // Try multiple selectors for cart drawer
      var cartDrawer = document.querySelector('#t4s-mini_cart') || 
                      document.querySelector('.t4s-drawer') || 
                      document.querySelector('[data-cart-drawer]') || 
                      document.querySelector('.cart-drawer') || 
                      document.querySelector('.mini-cart');
      
      if (cartDrawer) {
        // Add hidden classes
        cartDrawer.classList.add('t4s-dn', 't4s-drawer--hidden', 'cart-drawer--closed');
        cartDrawer.setAttribute('aria-hidden', 'true');
        
        // Remove open classes
        cartDrawer.classList.remove('t4s-drawer--open', 'cart-drawer--open', 'is-open');
        document.body.classList.remove('t4s-drawer-open', 'drawer-open', 'cart-drawer-open');
        
        // Hide overlay
        var overlay = document.querySelector('.t4s-drawer-overlay, .cart-drawer-overlay');
        if (overlay) {
          overlay.classList.remove('show');
          overlay.style.display = 'none';
        }
        
        // Restore body scroll
        document.body.style.overflow = '';
        
        // Reset positioning
        if (cartDrawer.id === 't4s-mini_cart') {
          cartDrawer.style.right = '';
          cartDrawer.style.left = '';
          cartDrawer.style.transform = '';
        }
      }
    }

    function getProductHandleFromVariant(variantId) {
      // This is a simplified implementation - you might need to adjust based on your setup
      return 'product-handle'; // Replace with actual product handle lookup
    }


  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-new-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Shopify money formatting for this section
    var modalRoot = document.getElementById('up-quick-shop-modal-new-product');
    var moneyFormat = (modalRoot && modalRoot.getAttribute('data-money-format')) || (window.Shopify && window.Shopify.money_format) || 'amount';
    if (typeof window.Shopify === 'undefined') window.Shopify = {};
    if (typeof window.Shopify.formatMoney !== 'function') {
      window.Shopify.formatMoney = function(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        var value = 0;
        var formatString = format || moneyFormat || 'amount';
        if (!isNaN(cents)) {
          value = parseInt(cents, 10);
        }

        function defaultOption(opt, def) {
          return (typeof opt === 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return '0'; }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.');
          var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          var centsPart = parts[1] ? (decimal + parts[1]) : '';
          return dollars + centsPart;
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var match = formatString.match(placeholderRegex);
        var valueString;

        switch (match && match[1]) {
          case 'amount':
            valueString = formatWithDelimiters(value, 2);
            break;
          case 'amount_no_decimals':
            valueString = formatWithDelimiters(value, 0);
            break;
          case 'amount_with_comma_separator':
            valueString = formatWithDelimiters(value, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            valueString = formatWithDelimiters(value, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            valueString = formatWithDelimiters(value, 2, '\u00A0', '.');
            break;
          case 'amount_with_period_and_space_separator':
            valueString = formatWithDelimiters(value, 2, '\u00A0', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            valueString = formatWithDelimiters(value, 0, '\u00A0');
            break;
          case 'amount_with_apostrophe_separator':
            valueString = formatWithDelimiters(value, 2, "'", '.');
            break;
          default:
            valueString = formatWithDelimiters(value, 2);
        }

        if (match) {
          return formatString.replace(placeholderRegex, valueString);
        }
        // Fallback: no token found in format string, return plain formatted number
        return valueString || formatWithDelimiters(value, 2);
      };
    }
    // Toast notification function
    function showToast(message) {
      // Create toast element
      var toast = document.createElement('div');
      toast.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #000; color: #fff; padding: 12px 20px; border-radius: 4px; z-index: 10000; font-size: 14px;';
      toast.textContent = message;
      document.body.appendChild(toast);
      
      // Remove toast after 3 seconds
      setTimeout(function() {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 3000);
    }

    // Quick Shop Modal functionality
    var quickShopModal = document.getElementById('up-quick-shop-modal-new-product');
    var quickShopModalBody = document.getElementById('up-quick-shop-modal-body-new-product');
    var quickShopModalClose = document.querySelector('#up-quick-shop-modal-new-product .up-quick-shop-modal-close');

    function showQuickShopModal(productId, cardId) {
      if (!productId || productId === 'no-product') {
        showToast('Product not available');
        return;
      }
      
      // Show loading state
      quickShopModalBody.innerHTML = '<div style="text-align: center; padding: 20px;">Loading...</div>';
      quickShopModal.setAttribute('data-current-card-id', cardId);
      quickShopModal.classList.add('up-quick-shop-modal--show');
      
      // Get product data from the Buy Now button's data attribute
      var button = document.querySelector('[data-card-id="' + cardId + '"] .up-buy-now-btn');
      var productData = null;
      
      if (button && button.getAttribute('data-product-data')) {
        try {
          productData = JSON.parse(button.getAttribute('data-product-data'));
        } catch (e) {
          console.error('Error parsing product data:', e);
        }
      }
      
      if (productData) {
        var modalContent = generateQuickShopContent(productData, cardId);
        quickShopModalBody.innerHTML = modalContent;
      } else {
        quickShopModalBody.innerHTML = '<div style="text-align: center; padding: 20px;">Product data not available</div>';
      }
    }

    function generateQuickShopContent(product, cardId) {
      var selectedVariant = product.selected_or_first_available_variant;
      var hasMultipleVariants = product.variants && product.variants.length > 1;
      
      var content = '<div class="up-quick-shop-content">';
      content += '<h3 style="margin-bottom: 16px;">' + (product.title || 'Product') + '</h3>';
      
      // Variant buttons if multiple variants
      if (hasMultipleVariants) {
        content += '<div class="up-variant-buttons" style="margin-bottom: 16px;">';
        content += '<label style="display: block; margin-bottom: 8px; font-weight: 600;">Select Variant:</label>';
        content += '<div class="up-variant-btn-group" style="display: flex; flex-wrap: wrap; gap: 8px;">';
        
        product.variants.forEach(function(variant) {
          var selected = variant.id === selectedVariant.id ? 'selected' : '';
          var disabled = !variant.available ? 'disabled' : '';
          var btnClass = 'up-variant-btn';
          if (selected) btnClass += ' up-variant-btn--selected';
          if (disabled) btnClass += ' up-variant-btn--disabled';
          
          content += '<button type="button" class="' + btnClass + '" data-variant-id="' + variant.id + '" data-price="' + (variant.price || 0) + '" data-compare="' + (variant.compare_at_price || 0) + '" ' + (disabled ? 'disabled' : '') + '>' + variant.title + '</button>';
        });
        
        content += '</div>';
        content += '</div>';
      }
      
      // Price display
      content += '<div class="up-price-display" style="margin-bottom: 16px;">';
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        content += '<span style="text-decoration: line-through; color: #999; margin-right: 8px;">' + Shopify.formatMoney(selectedVariant.compare_at_price, moneyFormat) + '</span>';
      }
      content += '<span style="font-size: 18px; font-weight: bold;">' + Shopify.formatMoney(selectedVariant.price, moneyFormat) + '</span>';
      content += '</div>';
      
      // Quantity selector
      content += '<div class="up-quantity-selector" style="margin-bottom: 16px;">';
      content += '<label style="display: block; margin-bottom: 8px; font-weight: 600;">Quantity:</label>';
      content += '<input type="number" class="up-quantity-input" value="1" min="1" style="width: 80px; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">';
      content += '</div>';
      
      // Action buttons
      content += '<div class="up-quick-shop-actions" style="display: flex; gap: 12px;">';
      content += '<button type="button" class="up-add-to-cart-btn" style="flex: 1; background: #000; color: #fff; border: none; padding: 12px; border-radius: 4px; font-weight: 600; cursor: pointer;">Add to Cart</button>';
      content += '<button type="button" class="up-view-product-btn" style="flex: 1; background: #f0f0f0; color: #000; border: 1px solid #ddd; padding: 12px; border-radius: 4px; font-weight: 600; cursor: pointer;">View Product</button>';
      content += '</div>';
      content += '</div>';
      
      return content;
    }

    // using Shopify.formatMoney defined above

    function hideQuickShopModal() {
      quickShopModal.classList.remove('up-quick-shop-modal--show');
    }

    function addToCartFromModal(variantId, quantity) {
      var button = document.querySelector('#up-quick-shop-modal-new-product .up-add-to-cart-btn');
      if (button) button.disabled = true;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function(res) {
        return res.ok ? res.json() : res.json().then(function(err) { throw err; });
      })
      .then(function(data) {
        if (button) button.disabled = false;
        
        // Update cart count in header
        updateCartCount();
        
        // Dispatch cart:updated event for theme compatibility
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: data }
        }));
        
        // Dispatch custom event for cart drawer refresh
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { cart: data }
        }));
        
        showToast('Added to cart successfully!');
        hideQuickShopModal();
        
        // Open cart drawer with proper theme integration
        setTimeout(function() {
          openCartDrawer();
        }, 200);
      })
      .catch(function() {
        if (button) button.disabled = false;
        showToast('Something went wrong');
      });
    }
    
    function updateCartCount() {
      // Update cart count in header
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .t4s-cart-count');
          cartCountElements.forEach(function(element) {
            element.textContent = cart.item_count;
          });
        })
        .catch(function(error) {
          console.error('Error updating cart count:', error);
        });
    }
    
    function openCartDrawer() {
      // Try multiple selectors for cart drawer, prioritize t4s-mini_cart
      var cartDrawer = document.querySelector('#t4s-mini_cart') || 
                      document.querySelector('.t4s-drawer') || 
                      document.querySelector('[data-cart-drawer]') || 
                      document.querySelector('.cart-drawer') || 
                      document.querySelector('.mini-cart');
      
      if (cartDrawer) {
        // Remove hidden classes
        cartDrawer.classList.remove('t4s-dn', 't4s-drawer--hidden', 'cart-drawer--closed');
        cartDrawer.setAttribute('aria-hidden', 'false');
        
        // Ensure it's positioned on the right side
        if (!cartDrawer.classList.contains('t4s-drawer__right')) {
          cartDrawer.classList.add('t4s-drawer__right');
        }
        
        // Add open classes
        cartDrawer.classList.add('t4s-drawer--open', 'cart-drawer--open', 'is-open');
        document.body.classList.add('t4s-drawer-open', 'drawer-open', 'cart-drawer-open');
        
        // Add overlay if not exists
        var overlay = document.querySelector('.t4s-drawer-overlay, .cart-drawer-overlay');
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 't4s-drawer-overlay cart-drawer-overlay';
          overlay.setAttribute('data-drawer-close', '');
          document.body.appendChild(overlay);
        }
        overlay.style.display = 'block';
        overlay.classList.add('show');
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        
        // Trigger cart refresh if theme supports it
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
        
        // Force right-side positioning with inline styles if needed
        if (cartDrawer.id === 't4s-mini_cart') {
          cartDrawer.style.right = '0';
          cartDrawer.style.left = 'auto';
          cartDrawer.style.transform = 'translate3d(0, 0, 0)';
        }
      }
    }
    
    function closeCartDrawer() {
      // Try multiple selectors for cart drawer
      var cartDrawer = document.querySelector('#t4s-mini_cart') || 
                      document.querySelector('.t4s-drawer') || 
                      document.querySelector('[data-cart-drawer]') || 
                      document.querySelector('.cart-drawer') || 
                      document.querySelector('.mini-cart');
      
      if (cartDrawer) {
        // Add hidden classes
        cartDrawer.classList.add('t4s-dn', 't4s-drawer--hidden', 'cart-drawer--closed');
        cartDrawer.setAttribute('aria-hidden', 'true');
        
        // Remove open classes
        cartDrawer.classList.remove('t4s-drawer--open', 'cart-drawer--open', 'is-open');
        document.body.classList.remove('t4s-drawer-open', 'drawer-open', 'cart-drawer-open');
        
        // Hide overlay
        var overlay = document.querySelector('.t4s-drawer-overlay, .cart-drawer-overlay');
        if (overlay) {
          overlay.classList.remove('show');
          overlay.style.display = 'none';
        }
        
        // Restore body scroll
        document.body.style.overflow = '';
        
        // Reset positioning
        if (cartDrawer.id === 't4s-mini_cart') {
          cartDrawer.style.right = '';
          cartDrawer.style.left = '';
          cartDrawer.style.transform = '';
        }
      }
    }

    // Event listeners
    document.addEventListener('click', function(e) {
      // Buy Now button click - show Quick Shop modal (only for new-product component)
      if (e.target.closest('.new-product-card .up-buy-now-btn')) {
        var btn = e.target.closest('.up-buy-now-btn');
        var productId = btn.getAttribute('data-product-id');
        var card = btn.closest('.new-product-card');
        var cardId = card ? card.getAttribute('data-card-id') : null;
        showQuickShopModal(productId, cardId);
      }
      
      // Cart drawer close events
      if (e.target.closest('[data-drawer-close]') || 
          e.target.closest('.drawer__close') ||
          e.target.closest('.cart-drawer__close') ||
          e.target.closest('.t4s-drawer__close')) {
        closeCartDrawer();
      }
      
      // Close cart drawer when clicking overlay
      if (e.target.classList.contains('t4s-drawer-overlay') || 
          e.target.classList.contains('cart-drawer-overlay')) {
        closeCartDrawer();
      }
      
      // Modal close
      if (e.target.closest('#up-quick-shop-modal-new-product .up-quick-shop-modal-close') || e.target.closest('#up-quick-shop-modal-new-product')) {
        if (e.target === quickShopModal || e.target.closest('#up-quick-shop-modal-new-product .up-quick-shop-modal-close')) {
          hideQuickShopModal();
        }
      }
      
      // Variant button selection
      if (e.target.closest('#up-quick-shop-modal-new-product .up-variant-btn')) {
        var btn = e.target.closest('.up-variant-btn');
        if (btn.disabled) return;
        
        // Remove selected class from all buttons
        var btnGroup = btn.closest('.up-variant-btn-group');
        var allBtns = btnGroup.querySelectorAll('.up-variant-btn');
        allBtns.forEach(function(button) {
          button.classList.remove('up-variant-btn--selected');
          // Reset to default styles
          button.style.background = '';
          button.style.borderColor = '';
          button.style.color = '';
        });
        
        // Add selected class to clicked button
        btn.classList.add('up-variant-btn--selected');
        btn.style.background = '#000';
        btn.style.borderColor = '#000';
        btn.style.color = '#fff';
        
        // Update price display
        var price = btn.getAttribute('data-price');
        var comparePrice = btn.getAttribute('data-compare');
        var priceDisplay = btn.closest('.up-quick-shop-content').querySelector('.up-price-display');
        if (priceDisplay) {
          var priceHtml = '';
          if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
            priceHtml += '<span style=\"text-decoration: line-through; color: #999; margin-right: 8px;\">' + Shopify.formatMoney(comparePrice, moneyFormat) + '</span>';
          }
          priceHtml += '<span style=\"font-size: 18px; font-weight: bold;\">' + Shopify.formatMoney(price, moneyFormat) + '</span>';
          priceDisplay.innerHTML = priceHtml;
        }
      }
      
      // Add to cart from modal
      if (e.target.closest('#up-quick-shop-modal-new-product .up-add-to-cart-btn')) {
        var btn = e.target.closest('.up-add-to-cart-btn');
        var modal = btn.closest('.up-quick-shop-content');
        var quantityInput = modal.querySelector('.up-quantity-input');
        var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        var variantId = null;
        var variantBtn = modal.querySelector('.up-variant-btn.up-variant-btn--selected');
        if (variantBtn) {
          // Get variant ID from the selected button
          variantId = variantBtn.getAttribute('data-variant-id');
        } else {
          // Fallback to original form variant ID
          var cardId = quickShopModal.getAttribute('data-current-card-id');
          var card = document.querySelector('[data-card-id="' + cardId + '"]');
          var form = card && card.querySelector('form.new-product-atc-form');
          var idInput = form && form.querySelector('input.js-variant-id');
          variantId = idInput ? idInput.value : null;
        }
        
        if (variantId) {
          addToCartFromModal(variantId, quantity);
        } else {
          showToast('Product variant not available');
        }
      }
      
      // View product from modal
      if (e.target.closest('#up-quick-shop-modal-new-product .up-view-product-btn')) {
        var btn = e.target.closest('.up-view-product-btn');
        var modal = btn.closest('.up-quick-shop-content');
        var cardId = quickShopModal.getAttribute('data-current-card-id');
        var card = document.querySelector('[data-card-id="' + cardId + '"]');
        var productLink = card && card.querySelector('a.new-product-button');
        if (productLink) {
          window.location.href = productLink.href;
        }
        hideQuickShopModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
